/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-11 11:56:29
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-21 17:24:15
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/Components/ItemWithIcon/index.tsx
 */
import React from 'react';

import { Icon } from '@/src/tools/icon';

import styles from './style.module.less';

type Props = {
  title: string;
  onClick: (data: any) => void;
  selected?: boolean;
};

function ItemWithIcon({ title, onClick, selected }: Props) {
  return (
    <div
      style={{
        backgroundColor: selected ? '#E5F7E9' : undefined,
      }}
      className={styles.container}
      onClick={onClick}>
      <div className={styles.title}>{title}</div>
      <div>
        <Icon type='iconright' className={styles.icon} />
      </div>
    </div>
  );
}

export default ItemWithIcon;
